export const CAMPAIGN_OBJECTIVES = {
    awareness: 'Awareness',
    traffic: 'Traffic',
    engagement: 'Engagement',
    leads: 'Leads',
    app_promotion: 'App promotion',
    sales: 'Sales',
} as const

export type CampaignObjectiveId = keyof typeof CAMPAIGN_OBJECTIVES

export function getCampaignObjectiveLabel(objectiveId: string | undefined | null): string {
    if (objectiveId != null && objectiveId in CAMPAIGN_OBJECTIVES) {
        return CAMPAIGN_OBJECTIVES[objectiveId as CampaignObjectiveId]
    }
    return CAMPAIGN_OBJECTIVES.awareness
}
